import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${isScrolled ? 'bg-ivory/90 backdrop-blur-md py-4 border-b border-line shadow-sm' : 'bg-transparent py-6 border-b border-transparent'}`} data-id="element-63" data-mp="1pwzwakvzz16u">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-64" data-mp="jnf5ofyeqx6a">
        <a href="#" className="font-serif text-2xl md:text-3xl font-bold tracking-widest text-ink" data-id="element-65" data-mp="ol8b36rvzn5i">
          LUMIÈRE{' '}
          <span className="text-gold-deep font-light text-xl md:text-2xl" data-id="element-66" data-mp="3s2796ks5xc2z">
            DENTAL
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-67" data-mp="uky473467c3">
          <div className="flex space-x-6" data-id="element-68" data-mp="5n4cv7djf8ih">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-ink-soft hover:text-gold-deep transition-colors text-sm uppercase tracking-widest font-medium" data-id="element-69" data-mp="34debairzcu5q">
                {link.name}
              </a>)}
          </div>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-gold text-ink px-6 py-3 rounded-sm font-semibold text-sm uppercase tracking-wider hover:bg-gold-deep hover:text-white transition-colors" data-id="element-70" data-mp="2wcq6ycnyxi81">
            Reservar Sesión VIP
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-ink" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Abrir menú" data-id="element-71" data-mp="2ddc8pij7hlbq">
          {isMobileMenuOpen ? <X size={28} data-id="element-72" data-mp="2s88nkelit6xs" /> : <Menu size={28} data-id="element-73" data-mp="2nbibs3gr0xi6" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} className="md:hidden bg-surface border-t border-line mt-4" data-id="element-74" data-mp="7juoz0vg8ld3">
          <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-75" data-mp="a754ws3rsbuv">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-ink hover:text-gold-deep transition-colors text-lg uppercase tracking-widest py-2" data-id="element-76" data-mp="f1itobnxfkqk">
                {link.name}
              </a>)}
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-gold text-ink px-6 py-4 rounded-sm font-semibold text-center uppercase tracking-wider mt-4" data-id="element-77" data-mp="xuwf9q5r2eti">
              Reservar Sesión VIP
            </a>
          </div>
        </motion.div>}
    </motion.nav>;
}